import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueToastr from '@deveodk/vue-toastr'
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
import vueSeo from '@deveodk/vue-seo'
import VueProgressBar from 'vue-progressbar'

Vue.use(VueProgressBar, {
    color: 'white',
    failedColor: 'red',
    height: '2px'
})

import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

const API_URL = process.env.API_URL

Vue.use(VueAxios, axios)
axios.defaults.baseURL = API_URL

Vue.use(vueSeo)

Vue.use(VueToastr, {
    defaultPosition: 'toast-bottom-right',
    defaultType: 'info',
    defaultTimeout: 5000
})



// WEBPACK FOOTER //
// ./src/shared/packages/packages.js